"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CreatorBase_1 = __importDefault(require("./CreatorBase"));
const CqlVersionCreator_1 = __importDefault(require("./CqlVersionCreator"));
const generated_1 = require("../generated");
class CqlIdentifierCreator extends CreatorBase_1.default {
    constructor(ctx) {
        super(ctx, {});
    }
    build() {
        var _a;
        CqlVersionCreator_1.default.setNameVersion((_a = this.ctx) === null || _a === void 0 ? void 0 : _a.children, this.cqlDao);
        this.cqlDao.name = this.findChildText(generated_1.cqlLexer.IDENTIFIER);
        return this.cqlDao;
    }
}
exports.default = CqlIdentifierCreator;
//# sourceMappingURL=CqlIdentifierCreator.js.map